import { useTranslation } from "react-i18next";
import { DnaChatBotThinkThreeIcon, InfoIcon } from "@/components/icons";

export default function AudienceSample() {
  const { t } = useTranslation();
  return (
    <div className="px-2 py-1.5 rounded-md inline-flex justify-end items-center gap-2 hover:bg-chunkBg relative group/main">
      <DnaChatBotThinkThreeIcon className="text-primary w-[22px] h-[16px]" />
      <div className="justify-start text-primary text-sm font-medium font-['Inter']">
        {t('components.audienceSample.useSampleAsGuide')}
      </div>
      <div className="w-[420px] p-4 absolute bg-white rounded-lg shadow-[0px_5px_8px_0px_rgba(18,18,23,0.04)] outline outline-1 outline-offset-[-1px] outline-zinc-100 flex-col justify-start items-start gap-4 right-0 top-[40px] z-[999] hidden group-hover/main:flex">
        <div className="self-stretch flex flex-col justify-start items-start gap-2">
          <div className="self-stretch justify-start">
            <span className="text-text-color-primary text-sm font-semibold font-['Inter'] leading-snug">
              {t('components.audienceSample.entrepreneursTitle')}{" "}
            </span>
            <span className="text-text-color-primary text-sm font-normal font-['Inter'] leading-snug">
              {t('components.audienceSample.entrepreneursDescription')}
            </span>
          </div>
        </div>
        <div className="self-stretch inline-flex justify-start items-center gap-1.5">
          <InfoIcon />
          <div className="justify-start text-text-color-secondary text-sm font-normal font-['Inter'] leading-snug">
            {t('components.audienceSample.clearInputsTip')}
          </div>
        </div>
      </div>
    </div>
  );
}
